const ResponsiveMenu = (function () {
  function init() {
    $('#nav').addClass('collapsed').before('<div id="menu"><span class="ph ph-list"></span> Menu</div>');
    $('#menu').click(() => {
      $('#nav').slideToggle('fast');
    });
    $(window).resize(() => {
      if (window.innerWidth > 641) {
        $('#nav').removeAttr('style');
      }
    });
  }

  return {
    init,
  };
}());

$(() => { ResponsiveMenu.init(); });
